<div class="snackbar-body-container">
    <span class="material-symbols-outlined success-icon" *ngIf="data.type === successSnackbarAlert">check</span>
    <span class="material-symbols-outlined error-icon" *ngIf="data.type === errorSnackbarAlert">close</span>
    <p class="alert-message">{{ data.message }}</p>
</div>
